import { DynamicFilterConfig } from '@/interfaces/DynamicFilterConfig';
import { logger } from "@/util/logger";

function dynamicFilterChangeEvent(value = ''): CustomEvent{
    return new CustomEvent('dynamicFilterSourceChange', {
        detail: {
            value
        }
    });
}

export class DynamicFilterController {
    config: DynamicFilterConfig
    parent: HTMLInputElement;
    parentSelected: HTMLInputElement;
    parentKey: HTMLInputElement
    parentSearch: HTMLInputElement;
    child: HTMLInputElement;
    childSearch: HTMLInputElement;
    childSelected: HTMLInputElement;

    previousParentValue: string;

    isFilterByEmp(): boolean {
        return this.config.ParentTable.Name === 'Emp';
    }

    setChildState(): void {
        this.setChildDisabled(this.parent.value === '');

        if (this.parent.value !== this.previousParentValue) {
            this.clearChild();
        }
    }

    setChildDisabled(disabled: boolean): void {
        this.child.disabled = disabled;
        this.childSearch.disabled = disabled;

        const label = this.parent.getAttribute('data-udf-label') || '';

        this.child.placeholder = disabled && label ? `Select a ${label} value first` : 'Type to search';
    }

    clearChild(): void {
        this.child.value = '';
        this.childSearch.value = '';
        this.childSelected.value = '';
        this.child.dispatchEvent(dynamicFilterChangeEvent());
    }

    cacheSelectors(): void {
        const base = '.js-filtertable';
        this.parent = document.querySelector(`${base}-${this.config.ParentTable.Name}`);
        this.parentSearch = document.querySelector(`${base}-${this.config.ParentTable.Name}-search`);
        this.parentSelected = document.querySelector(`[id$='${this.config.ParentTable.Name}_SelectedGLDim']`);
        this.parentKey = document.querySelector(`[id$='${this.config.ChildTable.Name}_GLDim_Filter']`);
        this.child = document.querySelector(`${base}-${this.config.ChildTable.Name}`);
        this.childSearch = document.querySelector(`${base}-${this.config.ChildTable.Name}-search`);
        this.childSelected = document.querySelector(`[id$='${this.config.ChildTable.Name}_SelectedGLDim']`);
    }

    attachEvents(): void {
        this.parent.addEventListener('dynamicFilterSourceChange', (e: CustomEvent) => {
            this.parentKey.value = e.detail.value;

            this.setChildState();
            this.previousParentValue = this.parent.value;
        });
    }
    
    validateConfig(): boolean {
        const childTableName = this.config.ChildTable.Name
        const parentTableName = this.config.ParentTable.Name
        const baseQuerySelector = '.js-filtertable';
        const childTableQuerySelector = `${baseQuerySelector}-${childTableName}`;
        const parentTableQuerySelector = `${baseQuerySelector}-${parentTableName}`;
        const childTableComponentExists = document.querySelector(childTableQuerySelector) !== null;
        const parentTableComponentExists = document.querySelector(parentTableQuerySelector) !== null;
        return childTableComponentExists && parentTableComponentExists;
    }
    
    init(): void {
        if (this.isFilterByEmp()) {
            return;
        }

        if (!this.validateConfig()) {
            logger.warn(`DynamicFilterController: ${this.config.ChildTable.Name} or ${this.config.ParentTable.Name} not found`);
            return;
        }

        this.cacheSelectors();
        this.attachEvents();

        this.previousParentValue = this.parent.value;

        // Update filtered options if parent field has a selected GLD value from previous page
        if (this.parentSelected.value.length > 0) {
            this.parent.dispatchEvent(dynamicFilterChangeEvent(this.parentSelected.value));
        }

        this.setChildState();
    }
    
    constructor(config: DynamicFilterConfig){
        this.config = config;
    }
}
